export default "__VITE_ASSET__C$WmQbqd__"